import {Box, Stack, Typography} from "@mui/material";
import engFlag from "../../resources/images/languages/en.png";
import itFlag from "../../resources/images/languages/it.png";
import {useTranslations} from "../../store/LanguageProvider";

const ListLanguageSelector = (props) => {
    const {changeLang, translations} = useTranslations();
    const size = props.size || 40;

    const style = {
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: size,
        height: size,
        borderRadius: '50%',
        border: '1px solid white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        color: 'white',
        transition: 'all ease-out .3s',
        cursor: 'pointer',
    }

    return <>
        <Typography textAlign='center' variant='body1' sx={{mt: 2, mb: 1}}>
            {translations.language}
        </Typography>
        <Stack direction='row' alignItems='center' justifyContent='center' gap={2}>
            <Box
                onClick={() => changeLang('it')}
                sx={{
                    ...style,
                    backgroundImage: `url(${itFlag})`
                }}>
            </Box>
            <Box
                onClick={() => changeLang('en')}
                sx={{
                    ...style,
                    backgroundImage: `url(${engFlag})`
                }}>
            </Box>
        </Stack>
    </>
}

export default ListLanguageSelector;